// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL ?? "https://beta.crm-api.primetecia.com.br/api";
// (05/09/2026) Aqui morava o anon JWT do Supabase antigo (projeto apagado em 22/08),
// compilado no bundle e visivel para qualquer um que abrisse o JS da pagina.
// O gateway do CRM NAO le este header — testado em producao: a rota responde 401
// igual com a chave real, com chave falsa e sem chave nenhuma. Quem autentica e o
// JWT do usuario (Authorization: Bearer). ⛔ NAO deixar vazio: o supabase-js recusa
// criar o client sem chave e o front inteiro morre na inicializacao.
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? "crm-prime-gateway";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});